var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpressjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 29,
    viewBox: "0 0 50 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 28.2479C48.1812 28.7102 47.0562 28.2682 46.0471 26.7532L38.8688 16.8249L37.8312 15.4501L29.4484 26.7862C28.4907 28.1501 27.4861 28.7432 25.6984 28.2607L36.4328 13.8553L26.4391 0.843092C28.1577 0.509061 29.3453 0.678888 30.3998 2.21783L37.8451 12.2699L45.3451 2.27257C46.3059 0.908699 47.339 0.390594 49.064 0.892953L45.1891 6.02901L39.9391 12.863C39.314 13.6439 39.3998 14.1785 39.9751 14.9324L50 28.2479ZM0.01275 13.6146L0.890627 9.29697C3.28126 0.752368 13.0782 -2.79826 19.8345 2.48138C23.7829 5.58664 24.7643 9.97928 24.5689 14.8998H2.31263C1.9785 23.7567 8.35502 29.1019 16.4843 26.3749C19.3358 25.4175 21.0154 23.185 21.8562 20.3924C22.2829 18.9929 22.9887 18.7739 24.3046 19.174C23.6329 22.6669 22.1172 25.5847 18.9139 27.4108C14.1282 30.1441 7.29639 29.2601 3.70313 25.4613C1.56225 23.2569 0.678002 20.4643 0.281251 17.4776C0.218626 16.9838 0.0937502 16.5137 0 16.0406C0.00825002 15.2323 0.01275 14.4244 0.01275 13.6161V13.6146ZM2.35313 13.0212H22.4656C22.3343 6.61685 18.3454 2.06787 12.8937 2.02926C6.90939 1.9824 2.61226 6.42303 2.35276 13.0212H2.35313Z",
    fill: "#FFFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 29,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressjs);
export default __webpack_public_path__ + "static/media/expressjs.14c3d40db48dcbe1f371311ee85518bd.svg";
export { ForwardRef as ReactComponent };